import {
  EntitySwitch,
  isComponentType,
} from '@backstage/plugin-catalog';
import { serviceEntityPage } from './ServiceEntityPage';
import { unclaimedEntityPage } from './UnclaimedEntityPage';

export const unclaimedPage = (
  <EntitySwitch>
    <EntitySwitch.Case if={isComponentType('repository')}>
      {serviceEntityPage}
    </EntitySwitch.Case>

    <EntitySwitch.Case>{unclaimedEntityPage}</EntitySwitch.Case>
  </EntitySwitch>
);
